import React from "react";
import PropTypes from "prop-types";

const DpdLocalCircleBox = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  width: "47",
  height: "46",
  viewBox: "0 0 47 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_2012_7822",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "11",
  y: "8",
  width: "25",
  height: "30"
}, /*#__PURE__*/React.createElement("rect", {
  x: "11.5",
  y: "8.85718",
  width: "24",
  height: "28.2857",
  fill: "#C4C4C4"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2012_7822)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.8338 14.9814L34.5026 15.192C32.1001 16.6072 29.7041 18.0289 27.295 19.4374C27.009 19.5679 26.8404 19.8723 26.8795 20.1878C26.9249 21.0303 26.8795 20.925 27.5677 21.3594C27.812 21.5529 28.1526 21.561 28.4054 21.3792C30.6131 20.0627 32.8339 18.7463 35.0416 17.4299L35.4442 17.1996C35.449 17.2916 35.449 17.3839 35.4442 17.476V29.5277C35.4528 29.9367 35.2241 30.3128 34.8598 30.4887L27.3924 34.9711C26.308 35.6293 25.2172 36.2875 24.1458 36.9457C23.7659 37.2086 23.2659 37.2086 22.8861 36.9457C19.3147 34.7868 15.7434 32.6454 12.172 30.5216C11.7522 30.3059 11.4976 29.8593 11.5227 29.3829C11.5227 25.4337 11.5227 21.5042 11.5227 17.5945C11.5227 17.476 11.5227 17.3641 11.5227 17.1996L11.8798 17.397L22.0419 23.3867C22.2734 23.4887 22.4127 23.7312 22.3861 23.9856C22.3861 26.9081 22.3861 29.8239 22.3861 32.7463V33.0425C22.3776 33.2376 22.485 33.419 22.6588 33.5033L23.2042 33.8126C23.3759 33.918 23.591 33.918 23.7627 33.8126L24.2821 33.523C24.4693 33.4417 24.5843 33.2483 24.5678 33.0425C24.5678 32.9636 24.5678 32.8846 24.5678 32.8056V22.8799C24.5678 22.7877 24.5678 22.7021 24.5678 22.61C24.574 22.4293 24.4783 22.2608 24.3211 22.1756L23.4964 21.6885L12.5097 15.192L12.172 14.988L12.4448 14.7971L22.8341 9.0444C23.232 8.79477 23.7349 8.79477 24.1328 9.0444C27.6067 10.9795 31.0677 12.8817 34.5286 14.7971L34.8338 14.9814Z",
  fill: "url(#paint0_linear_2012_7822)"
})), /*#__PURE__*/React.createElement("rect", {
  x: "1",
  y: "0.5",
  width: "45",
  height: "45",
  rx: "22.5",
  stroke: "black",
  strokeOpacity: "0.3"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2012_7822",
  x1: "11.6367",
  y1: "32.8623",
  x2: "23.8954",
  y2: "22.7235",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0060A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.36",
  stopColor: "#007ABE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.76",
  stopColor: "#0091D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#009ADF"
}))));

DpdLocalCircleBox.propTypes = {
  className: PropTypes.string
};
export default DpdLocalCircleBox;